import styled from 'styled-components';

import { SimpleButton } from '@components/formStyles';

export const HeaderWrapper = styled.div<{
  hideBoxShadow?: boolean;
  popoverVisible?: boolean;
}>`
  padding: 0px 12px 0px 12px;
  height: 105px;
  width: 100%;
  background: ${({ theme }) => theme.palette.white};
  align-items: center;
  position: relative;
  z-index: ${({ popoverVisible }) => (popoverVisible ? '1100' : '990')};
  box-shadow: 0px 10px 20px 0px rgba(58, 58, 58, 0.1);
  & a {
    text-decoration: none;
  }
  padding: 51px 0 10px 0;
`;
export const HeaderWrapperMobile = styled.div<{
  hideBoxShadow?: boolean;
  popoverVisible?: boolean;
}>`
  padding: 0px 12px 0px 12px;
  width: 100%;
  background: ${({ theme }) => theme.palette.white};
  align-items: center;
  position: relative;
  z-index: ${({ popoverVisible }) => (popoverVisible ? '1100' : '1000')};
  box-shadow: ${({ hideBoxShadow }) =>
    hideBoxShadow
      ? 'inset 0 -1px 0 0 rgba(0, 0, 0, 0)'
      : 'inset 0 -1px 0 0 rgba(41, 42, 44, 0.15)'};

  & a {
    text-decoration: none;
  }
  padding: 51px 0 10px 0;
  display: flex;
  height: 70px;
`;

export const HeaderBgWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    position: absolute;
    right: 100px;
    top: 10px;
    width: auto;
    height: 36px;
  }
`;

export const LineContainer = styled.div`
  display: flex;
  justify-content: end;
  padding-right: 100px;
  padding-top: 8px;
  width: 100%;
`;

export const Line = styled.div`
  background-color: ${({ theme }) => theme.palette.NL40};
  height: 1px;
  width: 55%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(223, 225, 230, 1) 55%
  );
`;

export const HeaderBgWrapperBorder = styled.div`
  display: none;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    display: block;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    height: 6px;
    background-color: ${({ theme }) => theme.palette.darkGrey};
  }
`;

export const HeaderContentWrapper = styled.div<{ profileName?: boolean }>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  position: absolute;
  padding-right: 100px;
`;
export const HeaderContentWrapperMobile = styled.div<{ profileName?: boolean }>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  grid-template-columns: minmax(600px, 800px);
  right: 12px;
  padding-right: 0px;
  bottom: ${({ profileName }) => (profileName ? 10 : 23)}px;
  top: ${({ profileName }) => (profileName ? 0 : 20)}px;
`;
export const VerticalLine = styled.div`
  border-left: 1px solid ${({ theme }) => theme.palette.D40};
  height: 20px;
  margin-right: 12px;
  margin-left: 12px;
`;
export const HeaderContactBox = styled.div`
  display: none;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    display: block;
    position: absolute;
    width: 100%;
    top: 0;
    right: 0;
    padding-top: 5px;
    box-shadow: 0px 10px 20px 0px rgba(58, 58, 58, 0.1);
  }
`;

export const HeaderContactBoxContent = styled.div`
  position: absolute;
  right: 1%;

  display: flex;
  align-items: center;
  & > a {
    text-decoration: none !important;
  }
`;

export const ContactBoxNumber = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.D500};
  padding: 0 10px 0 10px;
  border-right: 1px solid ${({ theme }) => theme.palette.white};
`;
export const ContactBoxLabel = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.D500};
  cursor: pointer;
`;
export const ContactBoxSubLabel = styled.span`
  font-size: 10px;
  font-weight: 300;
  color: ${({ theme }) => theme.palette.D100};
  line-height: 12.5px;
  cursor: context-menu;
`;
export const ContactWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.NL20};
  border-radius: 8px;
  padding: 8px;
`;
export const HeaderContainer = styled.div``;
export const HeaderLogoWrapper = styled.div<{ header?: boolean }>`
  left: 12px;
  top: 6px;
  display: flex;
  align-items: end;
  position: absolute;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    left: 100px;
    top: 10px;
  }
`;

export const HeaderLogo = styled.div`
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-right: auto;
    cursor: pointer;
    width: 113px;
    height: 36px;
  }
`;

export const HeaderMenu = styled.ul`
  display: none;
  && a {
    text-decoration: none;
  }

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0;
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    justify-items: center;
    align-items: center;
    gap: 30px;
  }
`;

export const HeaderBoxWrapper = styled.div<{ hasPoints?: boolean }>`
  @media ${`(max-width: 1400px)`} {
    right: 50px;
  }
`;

export const HeaderBox = styled.div`
  display: flex;
  align-items: center;

  a {
    display: inline;
  }
`;
export const HeaderBoxText = styled.div`
  display: flex;

  & a,
  & span {
    font-size: 16px;
    color: ${({ theme }) => theme.palette.darkGrey};
  }
`;

export const ResponsiveHeaderBox = styled.div<{ hasPoints?: boolean }>`
  display: flex;
  margin-top: ${({ hasPoints }) => (hasPoints ? '0' : 'auto')};
  align-items: center;
  gap: 16px;
`;

export const ResponsiveHeaderBoxIcon = styled.div``;

export const ProfileName = styled.div`
  font-size: 16px;
  font-weight: 900;
  color: ${({ theme }) => theme.palette.D400};
  cursor: default;
`;
export const MobilePointWrapper = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.black};
`;
export const ProfilContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.BR50};
  border-radius: 8px;
  padding: 4px 8px 4px 8px;
`;
export const PopoverWrapper = styled.div`
  position: absolute;
  top: 68px;

  left: 0;
  width: 100%;
  box-shadow: 1px 1px 10px 1px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  overflow: hidden;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 260px;
    right: 170px;
    top: 52px;
    left: auto;
  }
`;
export const PopoverWrapperMobile = styled.div`
  width: 100%;
  left: 0;
  top: 68px;
`;

export const StyledSimpleButton = styled(SimpleButton)`
  display: flex;
  align-items: center;
  margin-right: 12px;
`;
export const SignUpWrapper = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.palette.BR50};
  color: ${({ theme }) => theme.palette.D500};
  border-radius: 8px;
  padding: 8px;
  font-size: 16px;
  align-items: center;
  && a {
    text-decoration: none;
  }
`;
export const BasketBox = styled.div`
  position: relative;
  margin-left: 12px;
  cursor: pointer;
`;
export const DiffBox = styled.div`
  position: relative;
  margin-left: 0px;
  cursor: pointer;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-left: 12px;
  }
`;
export const Wrapper = styled.div`
  display: flex;
  && a {
    text-decoration: none;
  }
`;
